import React, { useEffect, useMemo } from 'react'
import StatusMessage, { useStatusMessage } from '../../../ui/StatusMessage/StatusMessage'
import usePromoSchedulesSubscription from '../../../api/marketing/usePromoSchedulesSubscription'
import useBrandsById from '../../../api/marketing/useBrandsById'
import PromosTable from './PromosTable'

function MarketingPromos() {
  const [statusMessage, setStatusMessage] = useStatusMessage()
  const { schedules, isLoading: isSchedulesLoading, error } = usePromoSchedulesSubscription()
  const { brandsById } = useBrandsById()

  useEffect(() => {
    if (!error) {
      return
    }

    setStatusMessage({
      show: true,
      type: 'fail',
      message: error,
      closeAfter: 6000,
    })
  }, [error, setStatusMessage])

  const rows = useMemo(
    () =>
      schedules.map((schedule) => ({
        ...schedule,
        brandLabel: schedule.brandId ? brandsById[schedule.brandId] || '—' : '—',
      })),
    [schedules, brandsById]
  )

  return (
    <>
      {statusMessage.show && (
        <StatusMessage className="Site-StatusMessage" type={statusMessage.type} message={statusMessage.message} />
      )}
      <PromosTable schedules={rows} isLoading={isSchedulesLoading} />
    </>
  )
}

export default MarketingPromos
